import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.less'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  constructor() { }

  @Input() links: Link[] = [];
  @Input() current: Link = new Link();

  ngOnInit() {
  }

}
export class Link {
  constructor(item: Link|void) {
    if(item instanceof Object) {
      this.link = item.link;
      this.name =  item.name;
    }
  }

  link: string = "";
  name: string = "";
}